<script setup lang="ts">
import { repository } from "~/repository";
import { useCommonStore } from "~/stores/common/store";
import HomeRow from "~/components/Home/HomeOld/HomeRow.vue";

const commonStore = useCommonStore();

const { data, pending } = await useAsyncData(
  async () => {
    const viewData = await repository.common.fetchViewData({
      viewName: "home",
    });
    await commonStore.fetchVideoProgress();
    return { viewData };
  },
  {
    server: false,
    lazy: true,
    transform: (response) => {
      return {
        collectionEntities: response.viewData.data.collection_list,
        heroEntity: response.viewData.data.feature_list[0],
        featuredEntities: response.viewData.data.feature_list.slice(0, 1),
      };
    },
  },
);
</script>

<template>
  <div class="mx-auto max-w-screen-xl">
    <div class="h-20"></div>
    <div v-if="pending" class="text-center">
      <ProgressSpinner class="mt-20 !h-20 !w-20" />
    </div>
    <div v-else-if="data" class="my-10 flex flex-col gap-10 px-4">
      <OldHomeHero :entity="data.heroEntity" />
      <HomeRow
        v-if="commonStore?.videoProgress?.length"
        :entities="commonStore.videoProgress"
        title="Continue Watching"
      />
      <HomeRow
        v-for="entity in data?.collectionEntities"
        :key="entity.id"
        :entities="entity.entities"
        :title="entity.title"
      />
    </div>
  </div>
</template>

<style scoped></style>
